// src/components/AdvertCard.js
import React from 'react';
import { Card, CardContent, CardMedia, Typography, Button, CardActions } from '@mui/material';

const AdvertCard = ({ image, title, description, link }) => {
  return (
    <Card sx={{ maxWidth: 1450, margin: 'auto' }} className='flashing-image'>
      <CardMedia
        component="img"
        height="140"
        image={image}
        alt={title}
      />
      <CardContent>
        <Typography gutterBottom variant="h5" component="div">{title}</Typography>
        <Typography variant="body2" color="text.secondary">{description}</Typography>
      </CardContent>
      <CardActions>
        <Button size="small" href={link} target="_blank">Learn More</Button>
      </CardActions>
    </Card>
  );
};

export default AdvertCard;
